import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { Calories_EndPoint } from "./ConstantsHealthCalculator";
import CaloriesTable from "./CaloriesTable";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة السعرات الحرارية (BMR)";
const DESCRIPTION =
  "حاسبة السعرات الحرارية هي عملية حسابية تقوم على حساب عدد السعرات الحرارية المستهلكة يومياً للشخص (ذكر /أنثى) بناءً على عدة عوامل مثل الوزن، والطول، والعمر، ونوع النشاط اليومي البدني";
const KEYWORDS =
  "كيفية حساب السعرات الحرارية التي يحتاجها الجسم, طريقة حساب السعرات الحرارية للجسم, حساب السعرات الحرارية التي يحتاجها الجسم في اليوم, حساب السعرات الحرارية حسب الوزن, معادلة حساب السعرات الحرارية, حاسبة السعرات الحرارية";
const OG_URL = "https://do-calculate.com/calculator/ar/calories/";
const apiEndpoint = `${SERVER_URL}/${Calories_EndPoint}`;
function CaloriesCalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [activity, setActivity] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleActivityChange = (event) => {
    setActivity(event.target.value);
  };
  const calculateCalories = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ activity, weight, height, age, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                حاسبة السعرات الحرارية هي عملية حسابية تقوم على حساب عدد السعرات
                الحرارية المستهلكة يومياً للشخص (ذكر /أنثى) بناءً على عدة عوامل
                مثل الوزن، والطول، والعمر، ونوع النشاط اليومي البدني. يمكنك حساب
                السعرات الحرارية الخاصة بجسمك و تقدير كم يحتاج الجسم سعرات
                حرارية. كما يمكنك ايضا استخدام هذه الحاسبة لمعرفة السعرات
                الحرارية اللازمة لزيادة وإنقاص الوزن
                <br />
                تأخذ هذه الحاسبة في الاعتبار عوامل مثل مستوى النشاط البدني
                والوزن والطول والعمر والجنس لتوفير توصيات سعرات حرارية مخصصة
                لاحتياجات جسمك الفردية. بالإضافة إلى ذلك، توفر لك توجيهات بسيطة
                لإدارة الوزن، بما في ذلك فقدان الوزن أو زيادة الوزن وتحقيق
                التوازن الصحي بناءً على السعرات الحرارية التي يحتاجها جسمك
                يوميًا.
                <br />
                استخدم حاسبة السعرات الحرارية لمعرفة كم يحتاج جسمك من سعرات
                حرارية للحفاظ على وزن صحي ونمط حياة نشط
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  السعرات الحرارية لـ زيادة/انقاص الوزن
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      الطول
                    </label>
                  </b>
                  <input
                    type="number"
                    id="heightNumber"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">سم</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      الوزن
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">كغ</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      العمر
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="6"
                    min="2"
                    max="20"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >الجنس</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      id="male"
                      name="gender"
                      value="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="male">
                      ذكر
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      id="female"
                      value="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="female">
                      أنثى
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <b>
                    <label htmlFor="activitySelect" className="form-label ms-2">
                      معدل النشاط
                    </label>
                  </b>
                  <select
                    id="activitySelect"
                    className="form-select"
                    value={activity}
                    onChange={handleActivityChange}
                  >
                    <option value="">-- إختر النشاط --</option>
                    <option value="sedentary">
                      قليل النشاط: نشاط بدني ضئيل جدًا أو عدم ممارسة التمارين
                      الرياضية
                    </option>
                    <option value="lightlyActive">
                      متوسط النشاط: تمارين رياضية خفيفة أو نشاط بدني لمدة 1-3
                      أيام في الأسبوع
                    </option>
                    <option value="moderatelyActive">
                      نشاط معتدل: تمارين رياضية معتدلة أو نشاط بدني لمدة 3-5
                      أيام في الأسبوع
                    </option>
                    <option value="active">
                      نشاط مرتفع: ممارسة تمارين رياضية مكثفة أو نشاط بدني لمدة
                      6-7 أيام في الأسبوع
                    </option>
                    <option value="veryActive">
                      نشاط مكثف: تمارين رياضية مكثفة جدًا أو نشاط بدني قوي
                      يوميًا
                    </option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateCalories}
                  disabled={isLoading}
                >
                  إحسب
                </button>
              </div>
              <div className="col-12 col-md-7">
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>النتائج : </h5>
                    </div>
                    <hr />
                    <CaloriesTable
                      caloriesBurned={result.caloriesBurned}
                      bmr={result.bmr}
                      maintain={result.dailyCalories.maintain}
                      mildLoss={result.dailyCalories.mildLoss}
                      lose={result.dailyCalories.lose}
                      extremeLoss={result.dailyCalories.extremeLoss}
                      mildGain={result.dailyCalories.mildGain}
                      gain={result.dailyCalories.gain}
                      extremeGain={result.dailyCalories.extremeGain}
                    ></CaloriesTable>{" "}
                    <br />
                    <div className="alert alert-warning">
                      عندما تفقد 0.5 كجم أو أكثر في الأسبوع، يُرجى استشارة
                      الطبيب.
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                حاسبة السعرات الحرارية - كم يحتاج الجسم سعرات حرارية:
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    السعرات الحرارية وكيفية حسابها لتحقيق التغذية السليمة{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  تعتبر السعرات الحرارية من أهم المفاهيم في عالم التغذية والصحة.
                  إن معرفة كمية السعرات الحرارية التي يحتاجها جسمك يمكن أن يكون
                  مفتاحًا لتحقيق التغذية السليمة والحفاظ على وزن صحي. في هذه
                  المقالة، سنتعرف على كيفية حساب السعرات الحرارية التي يحتاجها
                  جسمك وأهميتها في الحفاظ على صحتك.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}> ما هي السعرات الحرارية؟</h2>{" "}
                </u>{" "}
                <br />
                <p>
                  السعرات الحرارية هي وحدة قياس الطاقة. إنها الطاقة التي
                  يستخدمها جسمك لأداء وظائفه الأساسية مثل التنفس، وضخ الدم،
                  ووظائف الأعضاء الأخرى. كما يتطلب أيضًا القيام بأي نشاط بدني أو
                  حركة تحتاج إلى طاقة، سواء كنت تتمرن في صالة الألعاب الرياضية
                  أو تقوم بأعمال يومية.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيفية حساب السعرات الحرارية التي يحتاجها الجسم{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                هناك العديد من الطرق لحساب السعرات الحرارية التي يحتاجها جسمك،
                ولكن الطريقة الأكثر شيوعًا تستند إلى العوامل التالية:
                <ul>
                  <li>
                    الوزن: كلما زاد وزنك، زادت احتياجات جسمك من السعرات الحرارية
                    للحفاظ على وظائفه الحيوية.
                  </li>
                  <li>
                    الطول: الأشخاص الأطول يحتاجون عادة إلى مزيد من السعرات
                    الحرارية نظرًا للمزيد من الخلايا والأنسجة في أجسامهم.
                  </li>
                  <li>
                    العمر: كلما تقدمت في العمر، قد تحتاج إلى كمية أقل من السعرات
                    الحرارية نظرًا لتغييرات في معدل الأيض.
                  </li>
                  <li>
                    النشاط البدني: الأشخاص الذين يمارسون الرياضة بانتظام يحتاجون
                    إلى المزيد من السعرات الحرارية لتلبية احتياجات النشاط
                    البدني.
                  </li>
                </ul>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    تطبيق حساب السعرات الحرارية:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  يمكنك أيضًا استخدام تطبيقات الهواتف الذكية والأدوات على
                  الإنترنت لحساب السعرات الحرارية اليومية التي تحتاجها بناءً على
                  معلوماتك الشخصية. هذه التطبيقات تجعل العملية أسهل وأكثر دقة.
                  باختصار، فهم السعرات الحرارية وكيفية حسابها هو أمر أساسي
                  للعناية بصحتك والمحافظة على وزنك بشكل صحي. تأكد من تلبية
                  احتياجات جسمك من السعرات الحرارية واختيار الأطعمة الصحية التي
                  تحتوي على العناصر الغذائية الضرورية لتحقيق التوازن الغذائي
                  والصحة العامة.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    معادلة حساب السعرات الحرارية:
                  </h2>{" "}
                </u>
                <br />
                يتم حساب معدل الاستقلاب الأساسي (BMR) بناءً على العمر والوزن
                والطول والجنس باستخدام صيغة Harris-Benedict المعدلة. كانت معادلة
                Harris-Benedict واحدة من أقدم المعادلات المستخدمة لحساب معدل
                الأيض الأساسي (BMR) ، وهو مقدار الطاقة المنفقة يوميًا في حالة
                الراحة. تم تنقيحه في عام 1984 ليكون أكثر دقة
                <br /> <hr />
                <b>معادلة Revised Harris-Benedict : </b>
                <br />
                <div className="alert alert-info text-center">
                  <b>
                    <u>ذكور: </u>
                  </b>{" "}
                  <label>
                    معدل الأيض الأساسي (BMR) = 13.397W + 4.799H - 5.677A +
                    88.362
                  </label>{" "}
                  <br />
                  <b>
                    <u>إناث: </u>
                  </b>{" "}
                  <label>
                    معدل الأيض الأساسي (BMR) = 13.397W + 4.799H - 5.677A +
                    88.362
                  </label>
                </div>
                <div>
                  حيث:
                  <ul>
                    <li>W هو وزن الجسم بالكيلوغرام</li>
                    <li>H هو طول الجسم بالسنتيمتر</li>
                    <li>A هو العمر</li>
                    <li>F هو نسبة الدهون في الجسم بالنسبة المئوية</li>
                  </ul>
                </div>
                <br />
                <hr />
                يتم حساب إجمالي السعرات الحرارية المحروقة بناءً على مستوى النشاط
                ومعدل الاستقلاب الأساسي (BMR).
                <br />
                يتم حساب تقديرات السعرات الحرارية اليومية بناءً على أهداف الوزن
                المطلوبة، بما في ذلك الحفاظ على الوزن وفقدان الوزن وزيادة الوزن.
                <hr />
                <p>
                  تقوم هذه الحاسبة بحساب عدد السعرات الحرارية المحروقة ومعدل
                  الاستقلاب الأساسي (BMR) بناءً على مستوى النشاط والوزن والطول
                  والعمر والجنس. بالنسبة للأطفال والشباب الذين تتراوح أعمارهم
                  بين 2 إلى 20 عامًا ، تأخذ حاسبة مؤشر كتلة الجسم في الاعتبار
                  العمر والجنس وكذلك الطول والوزن.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كم عدد السعرات الحرارية التي تحتاجها؟
                </h3>
              </div>
              <div className="info-section-body">
                العدد الذي تحتاجه من السعرات الحرارية يعتمد على عمرك وحجم جسمك
                ومستوى نشاطك - معظم المراهقين والبالغين يحتاجون إلى حوالي 1500
                إلى 2500 سعر حراري يوميًا. كلما كنت أكبر حجمًا، كلما احتجت إلى
                المزيد من السعرات الحرارية للحفاظ على وزنك. إذا كنت ترغب في
                زيادة وزنك، ستحتاج إلى تناول مزيد من السعرات الحرارية، وإذا كنت
                ترغب في خسارة وزنك، ستحتاج إلى تناول سعرات حرارية أقل أو ممارسة
                المزيد من النشاط البدني. يمكنك حساب احتياجاتك الحرارية باستخدام
                صيغة هاريس بنيديكت.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كم عدد السعرات الحرارية في الدهون؟
                </h3>
              </div>
              <div className="info-section-body">
                الدهون تحتوي على تقريبًا 9 سعرات حرارية لكل غرام منها، وهي تعتبر
                أحد مصادر السعرات الحرارية العالية. عند تناول الدهون بكميات
                كبيرة، يمكن أن تسهم في زيادة عدد السعرات الحرارية التي تستهلكها
                يوميًا وبالتالي زيادة الوزن إذا لم يتم ممارسة النشاط البدني بشكل
                كافٍ لحرقها.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما تأثير النشاطات البدنية على السعرات الحرارية؟
                </h3>
              </div>
              <div className="info-section-body">
                التحرك ورفع الأشياء وأداء الأنشطة المختلفة تتطلب الطاقة، لذا
                كلما زادت حركتك وزادت الأشياء التي ترفعها أو تدفعها أو تجرها،
                زاد عدد السعرات الحرارية التي تحتاجها لأغراض الطاقة. بالإضافة
                إلى ذلك، التدريب على التحمل الذي يزيد من كتلة العضلات يزيد من
                معدل الأيض، مما يعني أن جسمك يحتاج إلى المزيد من السعرات
                الحرارية - حتى عندما لا تقوم بالكثير من الأنشطة. لذلك، بناء
                العضلات هو وسيلة جيدة لمساعدتك على الوصول إلى وزن صحي.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما مدى دقة حاسبات السعرات الحرارية؟
                </h3>
              </div>
              <div className="info-section-body">
                حاسبات السعرات الحرارية دقيقة إلى حد ما، ولكن قد لا تكون دقتها
                100٪. معظمها مبني على صيغة هاريس بنيديكت، والتي تحدد معدل الأيض
                الأساسي الذي يعني أساسًا عدد السعرات الحرارية التي تحتاجها فقط
                لتكون على قيد الحياة ومستيقظًا. تحتاج حاسبات السعرات الحرارية
                أيضًا إلى مراعاة مستويات نشاطك اليومية المعتادة، والتي قد تكون
                تقديرًا أكبر. من الصعب معرفة بالضبط عدد السعرات الحرارية التي
                تحترقها مع النشاط البدني وربما يختلف ذلك يوميًا. حاسبات السعرات
                الحرارية هذه هي وسيلة جيدة للبداية، ولكن إذا شعرت بأن وزنك لا
                يتغير بما فيه الكفاية، فقد تحتاج إلى ضبط استهلاكك اليومي للسعرات
                الحرارية أو ناتج الحرق وفقًا للحاجة.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هو أفضل طريقة لتتبع السعرات الحرارية؟
                </h3>
              </div>
              <div className="info-section-body">
                يمكنك استخدام دفتر ملاحظات أو مذكرة غذائية على الورق والبحث عن
                عدد السعرات الحرارية وقاموس السعرات الحرارية وقم بالحسابات
                يدويًا. ولكن في الوقت الحالي، أفضل طريقة هي استخدام موقع
                إلكتروني أو تطبيق لتتبع السعرات الحرارية، مثل MyFitnessPal.
                يمكنك اختيار الأطعمة التي تأكلها والمشروبات التي تشربها، وسيقوم
                الموقع بحساب السعرات الحرارية وإعطائك تقديرًا يوميًا للتغذية.
                بالإضافة إلى ذلك، يمكنك تتبع السعرات الحرارية التي يحترقها جسمك
                يوميًا. وهو مجاني.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماذا يعني أن "كل السعرات ليست متساوية"؟
                </h3>
              </div>
              <div className="info-section-body">
                كل السعرات متساوية من حيث الطاقة. كل غرام من الكربوهيدرات يحتوي
                على أربع سعرات حرارية، وكل غرام من البروتين يحتوي على أربع سعرات
                حرارية، وكل غرام من الدهون يحتوي على تسع سعرات حرارية. هذا لا
                يتغير. عبارة "كل السعرات ليست متساوية" تعني أن بعض مصادر السعرات
                الحرارية أفضل من غيرها. بشكل مختصر، يجب أن تحصل على معظم سعراتك
                من الأطعمة الغنية بالعناصر الغذائية. لذلك، على الرغم من أن 250
                سعر حراري من شوكولاتة قد يتم استخدامها بنفس الطريق مثل 250 سعر
                حراري من موزة أو تفاحة أو كمثرى مجتمعة، فإن الفاكهة بالطبع تعتبر
                أفضل لصحتك.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default CaloriesCalculator;
